<template lang="html">
    <div class="page" id="whatsInTheBag">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2 green_dark">
            <bag-list />
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import BagList from "@/components/Player/Bag/bag-list";
export default {
    name: "whats-in-the-bag",
    components: { FadeImage, BagList },
};
</script>

<style lang="scss"></style>
